// constants.js
// BaseURL
export const BASE_URL = process.env.REACT_APP_BASE_URL;
//HOMEPAGE
// HERO SECTION
export const HOMEPAGE_SLIDERS_URL = "/api/customer/sliders";
export const GET_MOBILE_SLIDERS_URL = "/api/customer/sliders?type=Mobile";
export const HOMEPAGE_CATEGORIES_URL = "/api/customer/categories";
export const HOMEPAGE_ADVERTS_URL = "/api/customer/adverts";

// PRODUCTS
export const GET_PRODUCT_BY_ID_URL = (id) => `/api/customer/products/${id}`;
export const GET_SPONSORED_PRODUCTS = "/api/customer/products/sponsored";
export const GET_TOP_SELLING_PRODUCTS = "/api/customer/products/top-selling";

export const GET_REVIEWS_BY_PRODUCT_ID_URL = (productId) =>
  `/api/customer/products/${productId}/reviews`;

export const GET_LATEST_PRODUCTS_URL = (location) =>
  location
    ? `/api/customer/products/latest?location=${location}`
    : `/api/customer/products/latest`;

export const GET_ALL_PRODUCTS_URL = (location) =>
  `/api/customer/products?location=${location}`; // Dynamic location filtering

export const SEARCH_PAGE_PRODUCTS_URL = (query, location, filters) =>
  `/api/customer/products/search-page?query=${query}&location=${location}&filters=${JSON.stringify(filters)}`;

export const SEARCH_PRODUCTS_URL = (query, location) =>
  `/api/customer/products/search?query=${query}&location=${location}`;

// Search products and stores
export const SEARCH_PRODUCTS_AND_STORES_URL = (query, location) =>
  location
    ? `/api/customer/search?query=${query}&location=${location}`
    : `/api/customer/search?query=${query}`;

export const GET_SHOP_PRODUCTS_URL = `/api/customer/shop/products`;

// GET VENDOR STORE
export const GET_VENDOR_DETAILS_URL = "/api/customer/details";
export const GET_VENDOR_PRODUCTS_URL = "/api/customer/products";

// AUTH
export const CUSTOMER_VERIFY_TOKEN_URL = "/api/customer/verify-token";
export const CUSTOMER_GOOGLE_LOGIN_URL = "/api/customer/auth/google";
export const CUSTOMER_FACEBOOK_LOGIN_URL = "/api/customer/auth/facebook";
export const CUSTOMER_SIGNUP_URL = "/api/customer/signup";
export const CUSTOMER_LOGIN_URL = "/api/customer/login";
export const CUSTOMER_LOGOUT_URL = "/api/customer/logout";
export const CUSTOMER_SEND_EMAIL_VERIFICATION_URL =
  "/api/customer/send-email-code";
export const CUSTOMER_VERIFY_EMAIL_URL = "/api/customer/verify-email";
// --- 🚨
export const CUSTOMER_CHANGE_PASSWORD_URL = "/api/customer/change-password";
export const CUSTOMER_SEND_RESET_LINK_URL = "/api/customer/forgot-password";
export const CUSTOMER_RESET_PASSWORD_URL = "/api/customer/reset-password";
export const CUSTOMER_DEACTIVATE_ACCOUNT_URL =
  "/api/customer/deactivate-account";

// ----

// CART
export const GET_CART_URL = "/api/customer/cart"; // Fetch all cart items
export const ADD_TO_CART_URL = "/api/customer/cart/add"; // Add item to cart
export const UPDATE_CART_ITEM_URL = "/api/customer/cart/update"; // Update item quantity
export const REMOVE_FROM_CART_URL = (itemId) =>
  `/api/customer/cart/remove/${itemId}`;
export const CLEAR_CART_URL = "/api/customer/cart/clear";

export const SYNC_CART_URL = "/api/customer/cart/sync"; // Sync cart with backend

export const APPLY_COUPON_URL = "/api/customer/cart/apply-coupon";
export const ESTIMATE_SHIPPING_URL = "/api/customer/cart/shipping";

// SAVED ITEMS
export const GET_SAVED_ITEMS_URL = "/api/customer/saved-items";
export const ADD_SAVED_ITEM_URL = "/api/customer/saved-items/add";
export const REMOVE_SAVED_ITEM_URL = "/api/customer/saved-items/remove";

// TAX
export const GET_TAX_URL = "/api/customer/tax";

// MANAGE ADDRESSES
export const GET_ADDRESSES_URL = "/api/customer/addresses";
export const ADD_ADDRESS_URL = "/api/customer/addresses/add";
export const UPDATE_ADDRESS_URL = "/api/customer/addresses/update";
export const DELETE_ADDRESS_URL = "/api/customer/addresses/delete";

// CHECKOUT
export const GET_DELIVERY_AREAS_URL = "/api/customer/delivery-areas";
export const CREATE_ORDER_URL = "/api/customer/orders";
export const FETCH_ORDER_URL = (orderId) => `/api/customer/orders/${orderId}`;
export const GET_CUSTOMER_PROFILE_URL = "/api/customer/profile";

// PAYMENT
export const INITIATE_PAYMENT_URL = "/api/customer/initiate-payment";

// HEADER
// WAREHOUSE
export const GET_WAREHOUSE_STATES_URL = "/api/customer/warehouse/states";

// REVIEWS
export const GET_REVIEWS_URL = (productId) =>
  `/api/customer/products/${productId}/reviews`;

export const ADD_REVIEW_URL = (productId) =>
  `/api/customer/products/${productId}/reviews`;
export const UPDATE_REVIEW_URL = (productId) =>
  `/api/customer/products/${productId}/reviews`;

export const HAS_PURCHASED_REVIEW_URL = (productId) =>
  `/api/customer/products/${productId}/has-purchased`;

export const GET_CATEGORIES_URL = "/api/customer/categories";

// ORDER
export const GET_CUSTOMER_ORDERS_URL = "/api/customer/orders";
export const GET_ORDER_DETAILS_URL = "/api/customer/orders/details";

// export const INITIATE_PAYMENT_URL = "/api/vendor/initiate-payment";
// ==============================================================================

// Vendor Registration URLs
export const VENDOR_EMAIL_VERIFICATION_URL = "/api/vendor/send-email-code";
export const VENDOR_VERIFY_EMAIL_URL = "/api/vendor/verify-email";
export const VENDOR_PHONE_VERIFICATION_URL = "/api/vendor/send-phone-code";
export const VENDOR_VERIFY_PHONE_URL = "/api/vendor/verify-phone";
export const VENDOR_COMPLETE_REGISTRATION_URL =
  "/api/vendor/complete-registration";
export const VENDOR_CHECK_INCOMPLETE_REGISTRATION_URL =
  "/api/vendor/check-incomplete-registration";
export const VENDOR_STORE_NAME_AVAILABILITY_URL =
  "/api/vendor/check-store-name";

// Login
export const VENDOR_LOGIN_URL = "/api/vendor/login";

// Logout
export const VENDOR_LOGOUT_URL = "/api/vendor/logout";

// Verify Token Url
export const VENDOR_VERIFY_TOKEN_URL = "/api/vendor/verify-token";

// Sliders
export const SLIDER_VENDOR_URL = "/api/vendor/sliders";

// Password Reset
export const VENDOR_SEND_RESET_LINK_URL = "/api/vendor/send-reset-link";
export const VENDOR_RESET_PASSWORD_URL = "/api/vendor/reset-password";
export const VENDOR_CHANGE_PASSWORD_URL = "/api/vendor/change-password";

// Header
export const VENDOR_HEADER_URL = "/api/vendor/header";

// Vendor Notifications URLs
export const VENDOR_NOTIFICATIONS_URL = "/api/vendor/notifications";
export const VENDOR_NOTIFICATION_READ_URL = (id) =>
  `/api/vendor/notifications/${id}/read`;

// Product Endpoints
export const CREATE_PRODUCT_URL = "/api/vendor/products";
export const GET_PRODUCTS_URL = "/api/vendor/products";
// export const GET_ALL_PRODUCTS_URL = "/api/vendor/all-products";
// export const GET_PRODUCT_BY_ID_URL = (id) => `/api/vendor/products/${id}`;
export const UPDATE_PRODUCT_URL = (id) => `/api/vendor/products/${id}`;
export const DELETE_PRODUCT_URL = (id) => `/api/vendor/products/${id}`;
// export const GET_CATEGORIES_URL = "/api/vendor/categories";
export const GET_CUBES_URL = "/api/vendor/cubes";
export const GET_STOCKING_PLANS_URL = "/api/vendor/stocking-plans";

// export const INITIATE_PAYMENT_URL = "/api/vendor/initiate-payment";

// Wallet Endpoints
export const WALLET_BALANCE_URL = "/api/vendor/wallet/balance";
export const WALLET_PAYOUTS_URL = "/api/vendor/wallet/payouts";
export const VERIFY_BANK_ACCOUNT_URL = "/api/vendor/wallet/verify-bank-account";
export const ADD_BANK_ACCOUNT_URL = "/api/vendor/wallet/add-bank-account";
export const UPDATE_BANK_ACCOUNT_URL = "/api/vendor/wallet/update-bank-account";
export const GET_BANK_ACCOUNT_URL = "/api/vendor/wallet/bank-account";
export const WALLET_TRANSACTION_HISTORY_URL = "/api/vendor/wallet/transactions";
export const WITHDRAW_TO_BANK_URL = "/api/vendor/wallet/withdraw";
// export const GET_ALL_BANKS_URL = "/api/vendor/banks/:country";
